/**
 * Created by Jie Gao on 2018-09-27.
 */
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {WildExpansionView} from "./WildExpansionView";
import {BonusBunniesParsedGameData} from "../../server/data/BonusBunniesParsedGameData";

export class WildExpansionController extends WinPresentationController {
    private _view:WildExpansionView;
    private _reels:string[][];
    private _overlayWildExpansions:boolean[][];
    private _timeLine:TimelineLite;
    private _bonusSymbolPositions:PIXI.Point[];
    private _wildSymbolPositions:PIXI.Point[];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "WildExpansionController", skippable : true});
        this._view = new WildExpansionView();
    }

    protected parseFeatureGameData(data:BonusBunniesParsedGameData):void {
        this._overlayWildExpansions = data.overlayWildExpansions;
        this._reels = data.reels;
        if(this._overlayWildExpansions) {
            this._bonusSymbolPositions = this.getBonusSymbolPositions();
            this._wildSymbolPositions = this.getWildSymbolPositions();
        }
    }

    private getBonusSymbolPositions():PIXI.Point[] {
        const bonusSymbolPositions:PIXI.Point[] = [];
        for(let i:number = 0; i < 4; i++) {
            for(let j:number = 1; j < 5; j++) {
                if(this._reels[i][j] == "B") {
                    bonusSymbolPositions.push(new PIXI.Point(i, j - 1));
                }
            }
        }
        return bonusSymbolPositions;
    }

    private getWildSymbolPositions():PIXI.Point[] {
        const wildSymbolPositions:PIXI.Point[] = [];
        for(let i:number = 0; i < 4; i++) {
            for(let j:number = 1; j < 5; j++) {
                if(this._reels[i][j] == "W") {
                    wildSymbolPositions.push(new PIXI.Point(i, j - 1));
                }
            }
        }
        return wildSymbolPositions;
    }

    protected hasWin():boolean {
        if(!this._overlayWildExpansions) {
            return false;
        }
        let hasExpansionWild:boolean = false;
        this._overlayWildExpansions.forEach((reel:boolean[], i:number) => {
            reel.forEach((symbol:boolean, j:number) => {
                if(symbol) {
                    hasExpansionWild = true;
                }
            });
        });

        return hasExpansionWild;
    }

    protected startWinPresentation():void {
        if(this._timeLine && this._timeLine.isActive()) {
            this._timeLine.pause();
            this._timeLine.kill();
        }
        if(this._bonusSymbolPositions.length < 4) {
            this._timeLine = new TimelineLite();
            this._timeLine.add(this._view.startPresentation(this._overlayWildExpansions, this._bonusSymbolPositions, this._wildSymbolPositions));
            this._timeLine.add(() => this.finish());
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted && this._timeLine && this._timeLine.isActive()) {
            this._timeLine.pause();
            this._timeLine.kill();
            this._view.abort();
        }
    }
}
